// src/pages/psytest/data/resultTemplates.js
export const RESULT_TEMPLATES = {
  audit: {
    badgeTitle: "Public Accounting - Audit / Assurance (審計與鑑證)",
    image: "/psytestImg/審計與鑑證.png",
    title: "你是守護專業信任的正義天秤",
    trait: "你細心、客觀且重視邏輯一致性。你偏好在明確的準則下運作，透過嚴謹的證據採集來確保財務資訊的真實性。",
    why: "你在結構化的工作環境中感到自在，且對於確保事物正確無誤有著高度的責任感。",
    tw: "主要服務於四大會計師事務所或中型事務所，擔任審計助理、審計組長或經理。",
    global: "透過會計師事務所的 Global Mobility 計畫轉調至海外辦公室，或在海外上市企業擔任內部稽核、合規官。",
    becker: "審計職涯路徑非常清晰，是累積專業信任的最佳起點。建議優先考取 美國註冊會計師（CPA），這將是你進入四大事務所後，升職或進入跨國企業的黃金通行證。",
  },

  tax: {
    badgeTitle: "Public Accounting - Tax (稅務諮詢)",
    image: "/psytestImg/稅務諮詢.png",
    title: "你是精通法規迷宮的策略專家",
    trait: "你擁有極強的法規敏感度與深度鑽研的耐性。比起頻繁的人際互動，你更喜歡在複雜的條文中為客戶找出最佳解法。",
    why: "你享受累積專門領域的深度，並能在變動的稅務法規中找到長期穩定的專業價值。",
    tw: "於會計師事務所稅務部擔任稅務顧問，或在國內大型集團財務部負責稅務申報與規劃。",
    global: "於國際事務所擔任跨國稅務諮詢師，協助企業處理移轉訂價、跨境投資架構規劃或雙邊稅務協議。",
    becker: "稅務專業需要深厚的學術功底與法規理解。考取美國註冊會計師（CPA）並選擇 TCP（美稅法規）考科，將奠定你不可取代的美稅專家地位。若欲以最短時間跨出第一步、拿下國際證照，亦可先考取美國註冊稅務師（EA）、立即掛牌執業，爾後接續完成美國 CPA 考照。",
  },

  fin_reporting: {
    badgeTitle: "Industry - Financial Accounting / Reporting (企業會計/財務報導)",
    image: "/psytestImg/企業財務會計與報吿.png",
    title: "你是企業運行的核心穩定器",
    trait: "你追求穩定與精確，偏好明確的責任分工。你擅長處理內部流程，確保公司的每一筆帳務都符合合規要求。",
    why: "你重視工作與生活的平衡，並希望在熟悉的體系中穩紮穩打地累積資歷。",
    tw: "於一般產業公司擔任總帳會計、主辦會計、財務專員，或在金控公司負責法定財務報告。",
    global: "於跨國企業擔任資深會計、合併報表專員，或負責區域性的財務共享中心管理。",
    becker: "企業會計職位穩定且需求量大。擁有美國註冊會計師（CPA）證照將能讓你在企業內部升遷中脫穎而出，邁向管理職。",
  },

  fpa: {
    badgeTitle: "Industry - FP&A / Management Accounting (財務規劃與分析)",
    image: "/psytestImg/財務規劃與分析.png",
    title: "你是驅動決策的商業導航員",
    trait: "你不只看數字，更看數字背後的商業意義。你擅長跨部門溝通，能將分析結果轉化為管理層的決策支援。",
    why: "你不甘於只產出報表，更希望參與策略討論，對公司的成長產生實質影響力。",
    tw: "於本土中大型企業或外商公司擔任財務分析師、管理會計師，負責預算編列、經營績效分析或投資評估。",
    global: "於跨國企業擔任區域營運財務長、財務經理，或在海外分公司擔任財務業務合作夥伴。",
    becker: "你需要結合會計專業與商業洞察。美國註冊會計師（CPA）證照能賦予你財務判斷的專業權威，讓你的決策分析更具說服力；升職為決策職務時，更可搭配美國管理會計師（CMA）強化鞏固重要意見的發言權與地位。",
  },

  consulting: {
    badgeTitle: "Consulting / Advisory (顧問與諮詢)",
    image: "/psytestImg/顧問與諮詢.png",
    title: "你是解決疑難雜症的策略軍師",
    trait: "你享受變動與不確定性，擁有極強的應變能力與溝通魅力。你擅長解決各種專案難題，並協助客戶進行轉型或優化。",
    why: "你喜歡高互動、高挑戰的工作節奏，追求快速成長與卓越的專業影響力。",
    tw: "於會計師事務所諮詢部門、管理顧問公司或財務諮詢公司，從事企業併購、風險管理或數位轉型諮詢。",
    global: "於全球頂尖顧問機構或跨國諮詢團隊，負責全球供應鏈重組、跨國併購後的財務整合或企業價值評估。",
    becker: "顧問業看重全面性的思考。美國註冊會計師（CPA）執照是你證明專業底蘊的門檻，能讓你在面對高層客戶時展現無可置疑的專業度、商用外語能力、與對美國法規熟悉的證明。",
  },

  global: {
    badgeTitle: "Cross-border / Global Mobility Path (跨國職涯發展)",
    image: "/psytestImg/跨國職涯發展.png",
    title: "你是勇闖邊境的國際專業人才",
    trait: "你具備開放的心態與極佳的環境適應力。你將會計視為一門國際語言，渴望在不同制度或文化間挑戰自我。",
    why: "你追求職涯的彈性與廣度，不希望被單一市場限制發展空間。",
    tw: "於外商銀行、外商在台分公司擔任財務職務，或在本土欲擴張海外版圖的企業負責海外投資專案。",
    global: "憑藉美國註冊會計師（CPA）通行全球的優勢，直接在美國或其他承認此資格的國家擔任執業會計師、財務主管，或在國際開發銀行、NGO 等組織服務。",
    becker: "美國會計師是你國際移動的通行證。Becker 的全球資源、課程、報考流程諮詢支援，將協助你順利接軌國際準則，開啟全球職涯。",
  },

  forensic: {
    badgeTitle: "Forensic Accounting (鑑識會計)",
    image: "/psytestImg/鑑識會計.png",
    title: "你是財務真相的科學神探",
    trait: "你對數字有種超乎常人的直覺，喜歡抽絲剝繭追查原因。你高度自律、重視證據，並能在高壓爭議的情境中保持判斷的中立性。",
    why: "你追求深度分析帶來的成就感，並希望透過專業揭發舞弊、維護公平制度。",
    tw: "於大型事務所的鑑識會計與舞弊防治部門服務，或在法律事務所協助訴訟支援、在金融監督管理機構負責金檢。",
    global: "於跨國法律事務所擔任鑑識分析師，在國際合規機構從事洗錢防制調查，或在海外大型企業擔任廉潔稽核、內部調查主管。",
    becker: "這是極度專業的利基市場。除了必備美國註冊會計師（CPA）資格之外，你還需要針對審計與調查流程進行深度強化；Becker 豐富的實務案例分析能協助你訓練這種神探直覺。",
  },
};
